/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlock } from './DatabasePageBlock';
import {
    DatabasePageBlockFromJSON,
    DatabasePageBlockFromJSONTyped,
    DatabasePageBlockToJSON,
} from './DatabasePageBlock';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseMapPageBlock
 */
export interface DatabaseMapPageBlock extends DatabasePageBlock {
    /**
     * 
     * @type {number}
     * @memberof DatabaseMapPageBlock
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseMapPageBlock
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseMapPageBlock
     */
    zoom?: number;
}

/**
 * Check if a given object implements the DatabaseMapPageBlock interface.
 */
export function instanceOfDatabaseMapPageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseMapPageBlockFromJSON(json: any): DatabaseMapPageBlock {
    return DatabaseMapPageBlockFromJSONTyped(json, false);
}

export function DatabaseMapPageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseMapPageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabasePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'zoom': !exists(json, 'zoom') ? undefined : json['zoom'],
    };
}

export function DatabaseMapPageBlockToJSON(value?: DatabaseMapPageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabasePageBlockToJSON(value),
        'latitude': value.latitude,
        'longitude': value.longitude,
        'zoom': value.zoom,
    };
}

